import { env } from "@/app/_utils/env";
import type { MePayload } from "@/app/_utils/authTypes";

/** Where to send the browser to start a WorkOS AuthKit sign-in. */
export async function fetchAuthorizationUrl(): Promise<string | null> {
  const res = await fetch(`${env.apiBaseUrl}auth/workos/authorize/`, {
    credentials: "include",
  });
  if (!res.ok) return null;
  const body = (await res.json().catch(() => null)) as {
    authorization_url?: string;
  } | null;
  return body?.authorization_url ?? null;
}

/** Email and password, verified by WorkOS server-side. Returns the me payload on success. */
export async function postPasswordLogin(
  email: string,
  password: string
): Promise<{ ok: boolean; payload?: MePayload; error?: string }> {
  const res = await fetch(`${env.apiBaseUrl}auth/workos/password/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    return { ok: false, error: body?.error ?? "Sign in failed. Please try again." };
  }
  return { ok: true, payload: body as MePayload };
}

/** Identity, roles and permissions for the signed-in session. 401 means no session. */
export async function fetchMe(): Promise<MePayload | null> {
  const res = await fetch(`${env.apiBaseUrl}auth/me/`, {
    credentials: "include",
  });
  if (!res.ok) return null;
  return (await res.json().catch(() => null)) as MePayload | null;
}
